import { render, staticRenderFns } from "./PreCheckButton.vue?vue&type=template&id=28bc98e9&scoped=true&"
import script from "./PreCheckButton.vue?vue&type=script&lang=ts&"
export * from "./PreCheckButton.vue?vue&type=script&lang=ts&"
import style0 from "./PreCheckButton.vue?vue&type=style&index=0&id=28bc98e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bc98e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
